function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTopChart = function SvgTopChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "transparent"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21418"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17700",
    d: "M4.333 3v2.667M3 4.333h2.667m-.667 8V15m-1.333-1.333h2.666M9.667 3l1.524 4.571L15 9l-3.809 1.429L9.667 15l-1.524-4.571L4.333 9l3.81-1.429z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
};

export default SvgTopChart;